// External libraries
import styled from '@emotion/styled';
import { string } from 'prop-types';

// Internal modules
import { getDefaultButtonStyles } from '@/styles';

const Button = styled.button`
  ${getDefaultButtonStyles};
  ${props => props.styleOverrides};
`;

Button.propTypes = {
  styleOverrides: string,
};

const LinkButton = styled.a`
  ${getDefaultButtonStyles};
  ${props => props.styleOverrides};
`;

LinkButton.propTypes = {
  styleOverrides: string,
};

export { Button, LinkButton };
